export default {
  views: {
    // details: {
    //   components: {
    //     main: {
    //       components: {
    //         overview: {
    //           "author": "Ustvaril",
    //           "created_at": "Ustvarjeno",
    //           "last_modified": "Nazadnje urejal",
    //           "updated_at": "Posodobljeno"
    //         },
    //         basic: {
    //           title: "Osebni podatki",
    //           name: "Ime in priimek",
    //           phone: "Telefonska številka",
    //           email: "Elektronski naslov",
    //           company: "Podjetje",
    //           address: "Naslov"
    //         }
    //       }
    //     },
    //     header: {
    //       "back_button": "Seznam strank",
    //       "edit_button": "Uredi stranko"
    //     }
    //   },
    //   index: {}
    // },
    list: {
      components: {
        header: {
          "add_installation": "Dodaj montažo"
        }
      },
      index: {
        "open": "Odpri",
        "edit": "Uredi",
        "delete": "Izbriši",
        "remove_installation": "Izbriši montažo",
        "youre_about_to_delete_installation_title_would_you_like_to_proceed_with_this_action": "Ste prepričani, da želite izbrisati montažo {name} {date}?",
        "cancel": "Prekliči",
        "installation_title_successfully_deleted": "Stranka {name} izbrisana",
        "customer": "Stranka",
        "vehicle": "Vozilo",
        "vin_number": "VIN številka",
        "date": "Termin"
      }
    }
  }
}
